import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';

@Entity()
export class UserAccount extends MongoEntity {
  static override _class = 'UserAccount';
  static override _collectionName = 'user_accounts';

  @Field(type => String) userId!: string;
  /**
   * Which channel this Sending Account sends on, and through whom.
   *
   * `unipile_email` is a value of its OWN rather than a mailbox filed under
   * `unipile_linkedin`, and that is load-bearing: the health watcher and the
   * safety module both select on `unipile_linkedin` and apply LinkedIn's daily,
   * weekly and warm-up rules to whatever they find. A mailbox stored under that
   * value would silently acquire another channel's limits, which ADR-0002
   * forbids in as many words.
   *
   * `instantly_email` is the retiring one — ADR-0001 moves email to Unipile.
   */
  @Field(type => String) provider!: 'instantly_email' | 'unipile_linkedin' | 'unipile_email';
  @Field(type => String) externalAccountId!: string;
  /**
   * Normalized PERSON identity of the account — the mailbox address for an email
   * account, the person's normalized name for a LinkedIn one. The provider mints
   * a NEW externalAccountId when an account is reconnected, so the id alone can
   * not tell that two rows are the same person; this can, and a partial unique
   * index on (userId, provider, identityKey) makes "the same account twice"
   * impossible at the database level. Absent (never null/empty) when no identity
   * could be read, so those rows stay out of the unique index rather than
   * colliding with each other. See helpers/user-account-constraints.ts.
   */
  @Field(type => String) identityKey?: string;
  @Field(type => String) displayName!: string;
  @Field(type => String) email?: string;
  @Field(type => String) status!: string;
  @Field(type => String) connectedAt!: string;
  @Field(type => String) aiEmployeeId?: string;
  @Field(type => Int) sentBaseline?: number;
  /**
   * Operator's "this mailbox is already warmed up" toggle (email only). When
   * set, the email rule module skips the 15/35/75 ramp and runs the account at
   * its full daily limit from day one — an established mailbox has a reputation
   * already and does not need throttling (spec story 12).
   */
  @Field(type => Boolean) emailWarmedManually?: boolean;
}
